import { TReduxActions } from '../../types/redux';
import { IRequestFormSchema } from '../../types/requestFormSchema';
import { ERequestFormSchemaActions } from '../../constants/actionTypes/requestFormSchema';

export const defaultState: IRequestFormSchema = {
  initialFormValue: {},
  firstStepCode: '',
  initialStepCode: '',
  stepsSchema: {},
  transformFields: [],
  skipSteps: [],
};

export function requestFormSchemaReducer(state: IRequestFormSchema = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ERequestFormSchemaActions.setRequestFormSchema:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
}
